import cn from 'classnames';
import { useState } from 'react';
import { TYPE_BUTTONS } from '../../../../../constans';
import { MAP_MARKETS } from '../../../../../constans/markets';
import Column from '../../../../Basic/Blocks/Column';
import Row from '../../../../Basic/Blocks/Row';
import Button from '../../../../Basic/Buttons/Button';
import DropDown from '../../../../Basic/Elements/DropDown';
import Icon from '../../../../Basic/Elements/Icon';
import filter_icon from '../../../../../assets/media/icons/filter.svg';
import styles from './styles.module.scss';
import Text from '../../../../Basic/WrapsStyle/Text';
import CheckButton from '../../../../Basic/Buttons/Check';

const FilterMarketsDropDown = ({ market = {}, setMarket = (_) => _, loadProducts = (_) => _ }) => {
  const [open, changeOpen] = useState(false);

  const onClick = (m, type = '') => {
    if (type === 'on') {
      setMarket({
        ...market,
        [m]: market[m] === true ? 'all' : true,
      });
    }
    if (type === 'off') {
      setMarket({
        ...market,
        [m]: market[m] === false ? 'all' : false,
      });
    }
  };

  const save = () => {
    loadProducts();
    changeOpen(false);
  };

  return (
    <div onClick={() => changeOpen(true)} className={styles.block}>
      <img src={filter_icon} alt="" className={styles.icon} />

      {open && (
        <DropDown close={save} styles={cn(styles.drop_down)}>
          <Row>
            <Column>
              {['ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'megamarket1', 'megamarket2'].map((m) => (
                <Row style={{ marginBottom: '10px' }} key={m}>
                  <Icon src={MAP_MARKETS[m]?.icon} className={styles.images_market} />
                  <CheckButton
                    checked={market[m] === true}
                    style={{ marginRight: '5px ' }}
                    onSelect={(v) => onClick(m, 'on')}
                  />
                  <Text style={{ marginRight: '15px' }}>Залито</Text>
                  <CheckButton
                    style={{ marginRight: '5px ' }}
                    checked={market[m] === false}
                    onSelect={(v) => onClick(m, 'off')}
                  />{' '}
                  <Text> Не залито</Text>
                </Row>
              ))}
            </Column>
            <Column>
              {['wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'].map((m) => (
                <Row style={{ marginBottom: '10px' }} key={m}>
                  <Icon src={MAP_MARKETS[m]?.icon} className={styles.images_market} />
                  <CheckButton
                    checked={market[m] === true}
                    style={{ marginRight: '5px ' }}
                    onSelect={(v) => onClick(m, 'on')}
                  />
                  <Text style={{ marginRight: '15px' }}>Залито</Text>
                  <CheckButton
                    style={{ marginRight: '5px ' }}
                    checked={market[m] === false}
                    onSelect={(v) => onClick(m, 'off')}
                  />{' '}
                  <Text> Не залито</Text>
                </Row>
              ))}
            </Column>
            <Column>
              {['yandex1', 'yandex3', 'yandex2', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'].map((m) => (
                <Row style={{ marginBottom: '10px' }} key={m}>
                  <Icon src={MAP_MARKETS[m]?.icon} className={styles.images_market} />
                  <CheckButton
                    checked={market[m] === true}
                    style={{ marginRight: '5px ' }}
                    onSelect={(v) => onClick(m, 'on')}
                  />
                  <Text style={{ marginRight: '15px' }}>Залито</Text>
                  <CheckButton
                    style={{ marginRight: '5px ' }}
                    checked={market[m] === false}
                    onSelect={(v) => onClick(m, 'off')}
                  />{' '}
                  <Text> Не залито</Text>
                </Row>
              ))}
            </Column>
          </Row>
          <Row className={styles.navigate}>
            <Button
              type={TYPE_BUTTONS.GREY}
              style={{ marginRight: '25px' }}
              onClick={() =>
                setMarket({
                  ozon1: 'all',
                  ozon2: 'all',
                  ozon3: 'all',
                  ozon4: 'all',
                  ozon5: 'all',
                  ozon6: 'all',
                  ozon7: 'all',
                  yandex1: 'all',
                  yandex2: 'all',
                  yandex3: 'all',
                  yandex4: 'all',
                  yandex5: 'all',
                  yandex6: 'all',
                  yandex7: 'all',
                  yandex8: 'all',
                  wb1: 'all',
                  wb2: 'all',
                  wb3: 'all',
                  wb4: 'all',
                  wb5: 'all',
                  wb6: 'all',
                  wb7: 'all',
                  megamarket1: 'all',
                  megamarket2: 'all',
                })
              }
            >
              Сбросить
            </Button>
            <Button type={TYPE_BUTTONS.WHITE} onClick={save}>
              Применить
            </Button>
          </Row>
        </DropDown>
      )}
    </div>
  );
};

export default FilterMarketsDropDown;
